import * as types from './constants';

export function setSelectedTab(index) {
  return { type: types.SET_SELECTED_TAB, index };
}
